import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";

const HeartToSoul = require("../../Assets/Images/HeartToSoul.png");
const heartToStrength = require("../../Assets/Images/HeartToStrength.png");
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    display: "flex",
    fontFamily: "Lato",
    padding: "20px",
  },
  maincontent: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#426B88",
    marginBottom: "5px",
  },
  topSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "flex-start",
  },
  coverTitle: {
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "30px",
    color: "#426B88",
    textTransform: "uppercase",
  },
  contentContainer: {
    textAlign: "left",
    marginTop: "20px",
  },
  paragraph: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
  },
  highlightText: {
    fontWeight: "700",
    fontSize: "18px",
    color: "#426B88",
    lineHeight: "30px",
    marginBottom: "5px",
  },
  coverImage: {
    width: "220px",
  },
  textContent: {
    width: "60%",
    marginLeft: "25px",
    marginTop: "10px"
  },
  pointsContainer: {
    marginTop: "10px",
    marginBottom: "20px",
  },
  pointsHeader: {
    fontWeight: "700",
    fontSize: "12px",
    color: "#245775",
    lineHeight: "18px",
    marginBottom: "5px",
  },
  pointText: {
    fontWeight: "400",
    fontSize: "12px",
    color: "#245775",
    marginBottom: "3px",
    lineHeight: "18px",
  },
  bottomSection: {
    alignItems: "center",
    marginTop: "20px",
  },
  bottomImage: {
    width: "406px",
    height: "96px",
  },
  text: {
    fontWeight: "700",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    marginTop: "10px",
  },
  noteContainer: {
    marginTop: 5,  
    padding: "10% 10% 0 10%",
    justifyContent: "center",
    alignItems: "center",
  },
  
  noteBold: {
    fontSize: 12,
    fontWeight: 700, 
    color: "#245775",
  },
  
  noteText: {
    fontSize: 12,
    fontWeight: 400, 
    color: "#426B88", 
    lineHeight: 2,    
    letterSpacing: 0,
    textAlign: "center",
    justifyContent: "center",    
  },
});

const GroupQuadrantFlowHeartToSoul2 = () => {
  return (
    <View style={styles.coverSection}>
      {/* HEADER */}
      <Text style={styles.maincontent}>Group Results:</Text>

      {/* TOP SECTION */}
      <View style={styles.topSection}>
        <Image src={HeartToSoul} style={styles.coverImage} />
        <View style={styles.textContent}>
          <Text style={styles.coverTitle}>HEART TO SOUL GROUPS</Text>
          <Text style={styles.highlightText}>Feels good. But why?</Text>

          {/* POTENTIAL STRENGTHS */}
          <View style={styles.pointsContainer}>
            <Text style={styles.pointsHeader}>POTENTIAL STRENGTHS</Text>
            <Text style={styles.pointText}>
              • Deep Connections and Emotional Engagement
            </Text>
            <Text style={styles.pointText}>• Values-Driven Purpose</Text>
            <Text style={styles.pointText}>• Creativity and Innovation</Text>
          </View>
        </View>
      </View>

      {/* POTENTIAL WEAKNESSES */}
      <View style={styles.contentContainer}>
        <Text style={styles.pointsHeader}>POTENTIAL WEAKNESSES</Text>
        <Text style={styles.pointText}>
          • Lack of Focus on Practical Execution
        </Text>
        <Text style={styles.pointText}>
          • Potential for Overemphasis on Consensus
        </Text>
        <Text style={styles.pointText}>
          • Risk of Isolation or Impracticalities
        </Text>

        <Text style={styles.paragraph}>
          This type of group is grounded in feelings and meaning, valuing inner
          experiences and simply "being" over outward actions and achievements.
        </Text>
        <Text style={styles.paragraph}>
          A Heart-to-Soul group is guided by identity, values, and purpose.
          Rather than leading from the front, they create environments where
          life, love, and leadership can flourish naturally.
        </Text>
        <Text style={styles.paragraph}>
          Often seen as poets or creatives, they focus on soulful, intangible
          influence rather than conventional, straightforward strategies.
        </Text>
      </View>

      {/* BOTTOM SECTION */}
      <View style={styles.bottomSection}>
        <Image src={heartToStrength} style={styles.bottomImage} />
      </View>

      <View style={styles.noteContainer}>
        <Text>
          <Text style={styles.noteBold}>Note:</Text>
          <Text style={styles.noteText}>
            {" "}
            Your group exhibits an equal flow between the Heart and Soul
            quadrants, moving seamlessly in both directions.
          </Text>
        </Text>
      </View>
    </View>
  );
};

export default GroupQuadrantFlowHeartToSoul2;
